export function getSelectedText({ mealQuantity, templateMealQuantity, assignmentQuantityForMeal, totalAddedMeals, moduleConfig, }) {
    if (mealQuantity > 0 && templateMealQuantity > 0) {
        return moduleConfig.MealSelectedText.replace("{selectedRecipes}", (assignmentQuantityForMeal - totalAddedMeals).toString()).replace("{mealQuantity}", (mealQuantity - totalAddedMeals).toString());
    }
    return null;
}
export function getAddedMealsTextWhenAssigning({ enableAddMeals, assignmentsComplete, assignmentQuantityForMeal, templateMealQuantity, totalAddedMeals, mealQuantity, moduleConfig, }) {
    const condition = enableAddMeals &&
        assignmentsComplete &&
        (templateMealQuantity === 0 || templateMealQuantity == null || assignmentQuantityForMeal > templateMealQuantity);
    if (condition) {
        return ` ${moduleConfig.AddedMealsText.replace("{addedMeals}", totalAddedMeals === 0 ? mealQuantity.toString() : totalAddedMeals.toString())}`;
    }
    return null;
}
export function getRemovedMealsText({ enableRemoveMeals, numRemovedAssignments, moduleConfig, }) {
    var _a;
    if (enableRemoveMeals && numRemovedAssignments > 0) {
        return ` ${(_a = moduleConfig.MealRemoval) === null || _a === void 0 ? void 0 : _a.TextValue.replace("{removedMeals}", numRemovedAssignments.toString())}`;
    }
    return null;
}
export function getAddedMealsTextWhenNotAssigning({ enableAddMeals, enableAssignRecipes, mealQuantity, templateMealQuantity, moduleConfig, }) {
    if (enableAddMeals &&
        !enableAssignRecipes &&
        mealQuantity > 0 &&
        (!templateMealQuantity || mealQuantity - templateMealQuantity > 0)) {
        const addedMeals = templateMealQuantity
            ? (mealQuantity - templateMealQuantity).toString()
            : mealQuantity.toString();
        return ` ${moduleConfig.AddedMealsText.replace("{addedMeals}", addedMeals)}`;
    }
    return null;
}
